const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function getToken() {
  return localStorage.getItem('token');
}

async function request(path, { method = 'GET', body, isFormData = false } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (!isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

/* ── auth ───────────────────────────────────────────────── */
export const login = async (email, password) => {
  const { token, user } = await request('/auth/login', { method: 'POST', body: { email, password } });
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  return user;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
};

export const createAdmin = (email, password) =>
  request('/auth/admins', { method: 'POST', body: { email, password } });

export const listAdmins = () => request('/auth/admins');

/* ── activity logs ──────────────────────────────────────── */
export const logPageVisit = (page) =>
  request('/activity/visit', { method: 'POST', body: { page } }).catch(() => {});

export const fetchActivityLogs = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return request(`/activity${qs ? `?${qs}` : ''}`);
};

/* ── vehicle entries ────────────────────────────────────── */
export const fetchVehicles = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return request(`/vehicles${qs ? `?${qs}` : ''}`);
};

export const createVehicleEntry = (payload) =>
  request('/vehicles', { method: 'POST', body: payload });

export const submitVehicleExit = (id, payload) =>
  request(`/vehicles/${id}/exit`, { method: 'PUT', body: payload });

/* ── chara types ────────────────────────────────────────── */
export const fetchCharaTypes = () => request('/chara-types');
export const addCharaType = (name) => request('/chara-types', { method: 'POST', body: { name } });
export const deleteCharaType = (id) => request(`/chara-types/${id}`, { method: 'DELETE' });

/* ── file upload ────────────────────────────────────────── */
export const uploadFile = async (file, folder) => {
  const form = new FormData();
  form.append('file', file);
  form.append('folder', folder);
  const { url } = await request('/upload', { method: 'POST', body: form, isFormData: true });
  return url;
};
